import { IEvaluationService } from "../../service/evaluation/EvaluationService";

export default class GetEvaluationBusinessRulesInteractor {
  private evaluationService: IEvaluationService;

  constructor(evaluationService) {
    this.evaluationService = evaluationService;
  }

  async execute(evaluationReviewBusinessRuleGroupId: number) {
    return this.evaluationService.getEvaluationBusinessRules(
      evaluationReviewBusinessRuleGroupId
    );
  }
}
